
class ImageSkeleton extends HTMLElement {
    #boundOnLoad;
    #image;
    connectedCallback() {
        if (this.hasAttribute("loaded")) return;
        this.init();
    }
    disconnectedCallback() {
        if (this.#image && this.#boundOnLoad) {
            this.#image.removeEventListener("load", this.#boundOnLoad);
        }
        this.removeAttribute("loaded");
        this.removeAttribute("aria-hidden");
    }
    init() {
        this.#image = this.nextElementSibling && this.nextElementSibling.tagName === "IMG" ? this.nextElementSibling : null;
        if (!this.#image) return;
        this.#boundOnLoad = () => this.markAsLoaded();
        if (this.#image.hasAttribute("src") && this.#image.complete) {
            this.markAsLoaded();
        } else {
            this.#image.addEventListener("load", this.#boundOnLoad);
        }
    }
    markAsLoaded() {
        this.setAttribute("loaded", "");
        this.setAttribute("aria-hidden", "true");
    }
}

customElements.define("image-skeleton", ImageSkeleton);
//# sourceMappingURL=image-skeleton.js.map
